//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { BodySecondaryText, SubtitleText } from '@components/atoms/text/Text';
import approveRightsSvg from '@images/uia/uia-approve-rights.svg';
import { UIAFooter } from '@uia/layout/UIAFooter';
import { UIA_RIGHTS_FLOW_TRACKING_IDS } from '@uia/rights/constants/uiaRightsConstants';

export function UIARightsOwned({ onClose }: { onClose: () => void }) {
  return (
    <Wrapper>
      <RightsApprovedContainer>
        <RightsApprovedImage src={approveRightsSvg} alt='rights owned' />
        <SubtitleText>Rights Owned</SubtitleText>
        <StyledText>
          You're free to add some products, and distribute this everywhere!
        </StyledText>
      </RightsApprovedContainer>

      <UIAFooter>
        <UIAFooter.Actions>
          <UIAFooter.ActionButton
            onClick={() => {
              onClose();
            }}
            trackingId={UIA_RIGHTS_FLOW_TRACKING_IDS.OWNED_RIGHTS_DONE_BUTTON}
          >
            Done
          </UIAFooter.ActionButton>
        </UIAFooter.Actions>
      </UIAFooter>
    </Wrapper>
  );
}
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
`;

const RightsApprovedContainer = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: calc(${theme.spacings[1]} * 25); // 100px
  `,
);

const StyledText = styled(BodySecondaryText)(
  ({ theme }) => `
    text-align: center;
    padding: 0 ${theme.spacings[7]};
  `,
);

const RightsApprovedImage = styled.img`
  width: 100px;
`;
